import React from 'react';
import { useTranslate, useLocalizedDataSelector } from '@hooks';

const DocsCommonParams = (props) => {
  const { tHtml } = useTranslate('docs', 'common');
  const currencies = useLocalizedDataSelector(({ currencyList }) => currencyList);
  const defaultCurrency = currencies.find((currency) => currency.platform === true);
  const defaultCode = defaultCurrency ? defaultCurrency.code : '';
  const codeList = `<ul>${currencies
    .map((currency) => currency.code)
    .sort()
    .map((code) => `<li>${code}</li>`)
    .join('')}</ul>`;

  return currencies.length && <div {...props}>{tHtml('params', { defaultCode, codeList })}</div>;
};

export default React.memo(DocsCommonParams);
